var View = require('views/base/view');
var ToolBarView = View.extend({
	template: require('./templates/toolbar')
});

module.exports = ToolBarView;